import { render, staticRenderFns } from "./choose-relate-dialog.vue?vue&type=template&id=04085132&scoped=true"
import script from "./choose-relate-dialog.vue?vue&type=script&lang=js"
export * from "./choose-relate-dialog.vue?vue&type=script&lang=js"
import style0 from "./choose-relate-dialog.vue?vue&type=style&index=0&id=04085132&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04085132",
  null
  
)

export default component.exports